import { render, staticRenderFns } from "./edit_modal.vue?vue&type=template&id=4a0a6c2a&"
import script from "./edit_modal.vue?vue&type=script&lang=js&"
export * from "./edit_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a0a6c2a')) {
      api.createRecord('4a0a6c2a', component.options)
    } else {
      api.reload('4a0a6c2a', component.options)
    }
    module.hot.accept("./edit_modal.vue?vue&type=template&id=4a0a6c2a&", function () {
      api.rerender('4a0a6c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/components/edit_modal.vue"
export default component.exports